import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

export const getUserAddresses = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/address/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, "Error retrieving user address book.", true)
    return err(message, status)
  }
}

interface UpdateAddressBookProps {
  id?: string | number | null
  name?: string | null
  address?: string | null
  address_2?: string | null
  address_3?: string | null
  city?: string | null
  postcode?: string | null
  country?: string | null
  default_address?: boolean | null
}

export const updateAddressBook = async ({
  ...allProps
}: UpdateAddressBookProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/address/update`, {
      ...allProps
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error adding or updating your address.", true)
    return err(message, status)
  }
}

interface RemoveItemProps {
  id: number | string
}

export const removeItem = async ({
  id
}: RemoveItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/address/remove`, {
      id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error deleting address.", true)
    return err(message, status)
  }
}